import { SVGProps, Ref, forwardRef } from 'react'
const SvgSingingPortrait = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 21.375a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0v0ZM19.5 19.125a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0v0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.75 21.375v-6.794a1.5 1.5 0 0 1 1.025-1.423l4.5-1.25a1.5 1.5 0 0 1 1.975 1.423v5.794M3.375 4.875a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0v0ZM.75 17.25a6.75 6.75 0 0 1 11.787-4.494"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSingingPortrait)
export default ForwardRef
